var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('img',{style:('width: '+ _vm.width + '; height: ' +  _vm.height),attrs:{"src":_vm.apiUrl(_vm.artist.image)}})])}
var staticRenderFns = []

export { render, staticRenderFns }